import { subHireCommitmentEntry } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getSubHireCommitmentDateSummary(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${subHireCommitmentEntry.subHireCommitmentEntryBase}date_summary/`, { params })
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    });
  },
  getSubHireCommitmentEntryList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(subHireCommitmentEntry.subHireCommitmentEntryBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getSubHireCommitmentEntryObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${subHireCommitmentEntry.subHireCommitmentEntryBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  updateSubHireCommitmentEntry(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${subHireCommitmentEntry.subHireCommitmentEntryBase}${payload.id}/`, payload.data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getSubHireCommitmentEntryLogs(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${subHireCommitmentEntry.subHireCommitmentEntryBase}${id}/commitment_logs/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
